enum OptionActionType {
    GET_OPTION_REQUEST = "GET_OPTION_REQUEST",
    GET_OPTION_SUCCEEDED = "GET_OPTION_SUCCEEDED",
    GET_OPTION_FAILED = "GET_OPTION_FAILED",

}

export default OptionActionType;
